import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import MakeReady from "./makeReady";
import MoveOut from "./moveOut";

import "./InboxItemPages.css";
import SDRefund from "./SDRefund";
import PropertyListing from "./propertyListing";
import BiWeeklyListing from "./BiWeeklyListing";
import MoveIn from "./moveIn";
import WorkOrderFollowUp from "./workOrderFollowUp";
import LeaseRenewal from "./leaseRenewal";
import PayOrQuit from "./PayOrQuit";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useState } from "react";

function InboxItemPages() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [checkedItems, setCheckedItems] = useState({}); // State for keeping track of checked items

  const fetchItemList = async () => {
    try {
      const tasksRef = collection(db, "tasks");
      const itemListRef = doc(tasksRef, "itemList");
      const specificItemRef = doc(itemListRef, "Assigned", id); // Construct a reference to the specific document

      const docSnapshot = await getDoc(specificItemRef); // Fetch the document

      if (docSnapshot.exists()) {
        const itemData = docSnapshot.data();
        const dataWithId = {
          ...itemData,
          docId: docSnapshot.id,
        };

        setData(dataWithId);
      } else {
        console.log("No document found with the provided ID!");
      }
    } catch (error) {
      console.error("Error fetching the document:", error);
    }
  };

  useEffect(() => {
    fetchItemList();
  }, [id]);

  useEffect(() => {
    const initialCheckedItems = {};

    data?.workItemList.forEach((item) => {
      initialCheckedItems[item.id] = item.status === "completed";
    });

    setCheckedItems(initialCheckedItems);
  }, [data]);
  console.log("hehehehehehheheh", data);
  return (
    <div className="inbox-item-pages">
      {data?.workFlowRunName.includes("Move Out") && (
        <MoveOut data={data} alreadyCheckedItems={checkedItems} />
      )}
      {data?.workFlowRunName.includes("Make Ready") && <MakeReady data={data} alreadyCheckedItems={checkedItems}/>}
      {data?.workFlowRunName.includes("SD Refund") && <SDRefund data={data} alreadyCheckedItems={checkedItems}/>}
      {data?.workFlowRunName.includes("Property Listing") && (
        <PropertyListing data={data} alreadyCheckedItems={checkedItems}/>
      )}
      {data?.workFlowRunName.includes("Listing Follow up") && (
        <BiWeeklyListing data={data} alreadyCheckedItems={checkedItems}/>
      )}
      {data?.workFlowRunName.includes("Move In") && <MoveIn data={data} alreadyCheckedItems={checkedItems}/>}
      {data?.workFlowRunName.includes("Work Order Follow up") && (
        <WorkOrderFollowUp data={data} alreadyCheckedItems={checkedItems}/>
      )}
      {data?.workFlowRunName.includes("Lease Renewal") && <LeaseRenewal data={data} alreadyCheckedItems={checkedItems}/>}
      {data?.workFlowRunName.includes("Pay / Quit") && <PayOrQuit data={data} alreadyCheckedItems={checkedItems}/>}
    </div>
  );
}

export default InboxItemPages;
